import { Box } from '@mui/material';

const UserActions = (props: IPropTypes) => {
    const { children } = props;
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '16px',
                height: '100%'
            }}
        >
            {children}
        </Box>
    );
};
interface IPropTypes {
    children: React.ReactNode;
}
export default UserActions;
